/* eslint-disable react-hooks/rules-of-hooks */
"use client";

import { CardProps, EntretienCreation } from "@/components/templates";
import styles from "./styles.module.scss";
import { creationData, steps } from "./data";
import uniqid from "uniqid";
import { MyButton, MyH2 } from "@/components/atoms";

const conceptionList: CardProps[] = creationData.map(
  ({ image, textsCard, title, slug }, id) => ({
    id,
    image,
    alt: title,
    slug,
    children: ({ id }: { id?: string }) => {
      return (
        <div className={styles.card}>
          <MyH2>{title}</MyH2>
          <div className={styles.paragraphs}>
            {(textsCard || []).map((el) => (
              <p key={uniqid()} dangerouslySetInnerHTML={{ __html: el }}></p>
            ))}
          </div>
          <div className={styles.btn_container}>
            <MyButton id={id} to={`/creation/${slug}`} label="Découvrir" />
          </div>
        </div>
      );
    },
  })
);

const breadCrumbs = [
  {
    url: "/",
    label: "Accueil",
  },
  {
    url: "/creation",
    label: "Création",
  },
];

export const Creation = () => {
  return (
    <EntretienCreation
      breadCrumbs={breadCrumbs}
      cards={conceptionList}
      steps={steps}
      title="Création"
      root="creation"
      text={`<p>Chaque projet étant unique, il nous parait nécessaire de l&apos;étudier en détail. Afin de construire ensemble la solution<br className="hidden lg:inline-block" />  qui vous
      correspond le mieux, nous avons mis en place une démarche qui a
      maintenant fait ses preuves.</p>`}
    />
  );
};
